<div>
    <mat-card>
        <div class="col-12 justify-content-center">
            <app-data-table
                [component]="'Reservations'"
                (searchEvent)="onSearchEvent($event)"
                (pageEvent)="onPageEvent($event)"
                (sortEvent)="onSortEvent($event)"
                [dataSource]="dataSource"
                [displayedColumns]="displayedColumns"
                [tableLength]="tableLength"
                [pageSize]="pageSize"
                [pageNumber]="pageNumber"
                [showPaginator]="true"
                [filterDefinitions]="filterDefinitions"
                [displayLoadingIndicator]="loading"
                [getCalculatedActionButtonText]="getActionButtonText.bind(this)"
                [getActionButtonColor]="getNewClaimButtonBackgroundColor.bind(this)"
                [getActionButtonIcon]="getActionButtonIcon.bind(this)"
                (actionClickedEvent)="onReservationActionClick($event)"
                [getStatusColor]="getReservationStatusColor"
                [allowPropertyReservationUpdateBoolean]="true"
                [initialPageSize]="this.initialPageSize"
                [initialPageNumber]="this.initialPageNumber"
                [initialKeyword]="this.initialKeyword"
                [initialSort]="this.initialSort"
                (massUpdateReservationPolicyEvent)="onReservationUpdatePolicyEvent($event)"
                (massUpdateReservationStatusEvent)="onReservationUpdateStatusEvent($event)"
            >
            </app-data-table>
        </div>
    </mat-card>
</div>